import { twMerge } from 'tailwind-merge';
import SortableHeader from './SortableHeader';
import type { OnSort, SortField, TableHeader } from '@/types';

/**
 * This component is used to display the table header.
 * @param headerData - The header data.
 * @param onSort - The function to call when the header is sorted.
 * @param sortField - The sort field.
 * @returns The table header component.
 */
interface TableHeaderProps {
  headerData: TableHeader[];
  onSort: OnSort;
  sortField: SortField | null;
}

export const headerTextStyle = 'text-sm font-medium text-textMedGrey text-left';

const TableHeader = ({ headerData, onSort, sortField }: TableHeaderProps) => {
  return (
    <thead className="bg-white border-b border-borderMedGrey">
      <tr>
        {headerData.map((header) => {
          const { id, label, sortable, styleOptions, className } = header;
          const { align } = styleOptions || {};

          if (sortable) {
            return (
              <SortableHeader
                id={id}
                align={align}
                key={id}
                className={className}
                sortField={sortField!}
                onSort={onSort}
              >
                {label}
              </SortableHeader>
            );
          }
          const alignStyles = align === 'right' ? 'text-right' : 'text-left';
          return (
            <th className={twMerge(headerTextStyle, alignStyles, className)} key={id}>
              {label}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHeader;
